import gemmaIcon from '../assets/gemma-icon.svg';

const pub = String(process.env.PUBLIC_URL || '').replace(/\/$/, '');
/** URL z hashem z bundla; GemmaAvatar używa tego samego (jeden request, brak kolizji id w wielu SVG). */
export const GEMMA_ICON_URL: string = (gemmaIcon.startsWith('http') ? '' : pub) + gemmaIcon;

export type GemmaSenderLike = {
  sender?: { displayName?: string | null; email?: string | null; avatarUrl?: string | null } | null;
  senderId?: string | null;
};

/**
 * Domyślny `user_id` konta bota w czacie (jak w SQL INSERT).
 * Zawsze ukrywany w liście „Prywatne rozmowy” — osobno zostaje wpis z GemmaAvatar.
 */
export const INTERNAL_CHAT_GEMMA_SYSTEM_USER_ID = 'internal-chat-gemma';

/** Ten sam `user_id` co `INTERNAL_CHAT_GEMMA_BOT_USER_ID` na backendzie — lista DM / wzmianki. */
export function getInternalChatGemmaBotUserId(): string {
  return String(process.env.REACT_APP_INTERNAL_CHAT_GEMMA_BOT_USER_ID || '').trim();
}

/** Czy to konto systemowe Gemmy w czacie (stały id lub REACT_APP_*). */
export function isInternalChatGemmaSystemUserId(userId: string | null | undefined): boolean {
  if (userId == null || userId === '') return false;
  const id = String(userId).trim();
  if (id === INTERNAL_CHAT_GEMMA_SYSTEM_USER_ID) return true;
  const fromEnv = getInternalChatGemmaBotUserId();
  return fromEnv !== '' && id === fromEnv;
}

/** Czy wiadomość jest od bota Gemmy (użyj GemmaAvatar zamiast <Avatar src>). */
export function isGemmaMessage(m: GemmaSenderLike): boolean {
  if (m.senderId != null && isInternalChatGemmaSystemUserId(m.senderId)) return true;
  const em = (m.sender?.email || '').toLowerCase();
  if (em.includes('gemma@')) return true;
  const dn = (m.sender?.displayName || '').trim().toLowerCase();
  if (dn === 'gemma') return true;
  return false;
}

/** Avatar z API albo undefined; dla Gemmy i tak renderuj GemmaAvatar w UI. */
export function resolveGemmaMessageAvatarUrl(m: GemmaSenderLike): string | undefined {
  if (isGemmaMessage(m)) return undefined;
  return m.sender?.avatarUrl || undefined;
}
